<app-loader></app-loader>
<div class="app-page__wrapper">
    <app-header-page></app-header-page>
    <div class="page-container">
        <div class="html-content">
                <div [innerHTML]="contactSupportContent" class="html-content">
                </div>
        </div>
    </div>
    <div>
        <app-footer></app-footer>
    </div>
</div>
